import { FC } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { NumberInput } from "../core/NumberField";
import { useStyles } from "../../useStyles";
import { Switch } from "../core/Switch";
import { GeneralPowerIcon } from "../core/icons/Icons";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { Grid, InputLabel } from "@material-ui/core";
import { FormControlLabel } from "../core/FormControlLabel";
import { Checkbox } from "../core/Checkbox";

export const IncreaseCurrentElectricSharedElectricityForm: FC = () => {
    const classes = useStyles();
    const { values, getFieldProps, setValues } =
        useFormModel<ChangeNames.INCREASE_CURRENT_ELECTRIC_SHARED_ELECTRICITY>();
    return (
        <BoxedInputWithIconAndOptionalSwitch
            icon={<GeneralPowerIcon />}
            content={
                <>
                    <p className={classes.label} style={{ marginBottom: 8 }}>
                        Allgemeinstrom in Mehrfamilienhäusern
                    </p>
                    <p className={classes.p} style={{ marginTop: 0, marginBottom: 24 }}>
                        z. B. Treppenhausbeleuchtung
                    </p>
                </>
            }
            useSwitch={
                <Switch
                    checked={values.increaseCurrentElectricSharedElectricity.value.installed}
                    {...getFieldProps("increaseCurrentElectricSharedElectricity.value.installed")}
                    onChange={(e, checked) =>
                        setValues((values) => {
                            values.increaseCurrentElectricSharedElectricity.value.installed =
                                checked;
                            values.increaseCurrentElectricSharedElectricity.value.demand.amount =
                                checked ? 0 : null;
                        })
                    }
                />
            }
            detailCondition={values.increaseCurrentElectricSharedElectricity.value.installed}
            detail={
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <InputLabel className={classes.labledTextfieldLabel}>
                            Summe der Leistung
                        </InputLabel>
                        <NumberInput
                            className={classes.textField}
                            decimalScale={
                                values.increaseCurrentElectricSharedElectricity.value.demand
                                    .precision
                            }
                            allowLeadingZeros={false}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            adornment={
                                values.increaseCurrentElectricSharedElectricity.value.demand.unit
                            }
                            value={
                                values.increaseCurrentElectricSharedElectricity.value.demand
                                    .amount || ""
                            }
                            placeholder="0"
                            onValueChange={(v) =>
                                setValues((values) => {
                                    values.increaseCurrentElectricSharedElectricity.value.demand.amount =
                                        v.floatValue || null;
                                })
                            }
                            error={values.increaseCurrentElectricSharedElectricity.error != null}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControlLabel
                            style={{ marginTop: -12 }}
                            isCheckBox={true}
                            control={
                                <Checkbox
                                    value="ja"
                                    checked={
                                        values.increaseCurrentElectricSharedElectricity.value
                                            .notKnown
                                    }
                                    onChange={(event, checked) =>
                                        setValues((values) => {
                                            values.increaseCurrentElectricSharedElectricity.value.notKnown =
                                                checked;
                                        })
                                    }
                                />
                            }
                            label="Leistungswert nicht bekannt"
                            error={false}
                        />
                    </Grid>
                </Grid>
            }
        />
    );
};
